import { CatalogDto, CatalogModel } from '../../data-layer/catalogs/types';
import { fromBusinessLiteDto } from '../business/toBusinessModel';

export const fromCatalogDto = (catalogDto: CatalogDto): CatalogModel => ({
    title: catalogDto.title,
    ownersData: catalogDto.owners_data
        ? {
              author: {
                  id: catalogDto.owners_data?.author.id,
                  displayName: catalogDto.owners_data?.author.display_name,
                  avatarUrl: catalogDto.owners_data?.author.avatar_url,
                  shareLink: catalogDto.owners_data?.author.share_link,
              },
              shop: {
                  displayUrl: catalogDto.owners_data?.shop.display_url,
              },
              isOwner: catalogDto.owners_data?.is_owner,
          }
        : undefined,
    business: catalogDto.business ? fromBusinessLiteDto(catalogDto.business) : undefined,
    productsCount: catalogDto.products_count,
});
